/**
 * Médias étapes 10–12 : ne s'exécute que lorsque l'étape concernée est visible
 * (évite d'initialiser Swiper sur un conteneur caché au chargement → refresh aléatoire).
 */
(function () {
  'use strict';

  var bootTimer = null;

  function splitUrls(raw) {
    if (!raw) return [];
    return String(raw).split('|||').map(function (u) { return u.trim(); }).filter(Boolean);
  }

  function thumbFromUrl(url) {
    if (!url) return '';
    if (url.indexOf('width=') !== -1) {
      return url.replace(/width=\d+/i, 'width=600');
    }
    return url;
  }

  function isStepVisible(stepNum) {
    var el = document.querySelector('.questionnaire-step[data-step="' + stepNum + '"]');
    return el && el.style.display !== 'none';
  }

  function applyUrlsToImg(img, urls) {
    if (!img || !urls.length) return false;
    var display = thumbFromUrl(urls[0]);
    var full = urls[urls.length - 1];
    img.loading = 'eager';
    img.classList.remove('lazyload', 'lazyloaded', 'lazyloading');
    img.removeAttribute('data-src');
    img.src = display;
    img.setAttribute('data-fallback-src', display);
    img.setAttribute('data-lightbox-src', full);
    return true;
  }

  function urlsFromOption(opt) {
    if (!opt) return [];
    return splitUrls(
      opt.getAttribute('data-color-images') ||
      opt.getAttribute('data-support-images-thumb') ||
      opt.getAttribute('data-support-images')
    );
  }

  function initAccessoriesStatic() {
    if (!isStepVisible(12)) return;
    document.querySelectorAll('.step12-accessories-option').forEach(function (card) {
      var select = card.querySelector('.accessories-color-select');
      var img = card.querySelector('.accessory-item-image img, .container-item-image img');
      if (!select || !img) return;
      if (!select.value) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value) {
            select.selectedIndex = i;
            break;
          }
        }
      }
      var opt = select.options[select.selectedIndex];
      applyUrlsToImg(img, urlsFromOption(opt));
      if (!select.dataset.qMediaSimpleBound) {
        select.dataset.qMediaSimpleBound = '1';
        select.addEventListener('change', function () {
          applyUrlsToImg(img, urlsFromOption(select.options[select.selectedIndex]));
        });
      }
    });
  }

  function boot() {
    if (bootTimer) {
      clearTimeout(bootTimer);
    }
    bootTimer = setTimeout(function () {
      bootTimer = null;
      initAccessoriesStatic();
    }, 50);
  }

  window.__setArcheColorStaticPreview = function (colorName) {
    var select = document.getElementById('arche-color');
    var optionEl = document.getElementById('arche-artificial');
    if (!select || !optionEl) return false;

    var targetName = colorName || select.value;
    if (!targetName) return false;

    var selectedOption = null;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === targetName) {
        selectedOption = select.options[i];
        break;
      }
    }
    var urls = urlsFromOption(selectedOption);
    if (!urls.length) return false;

    var targetImg =
      optionEl.querySelector('.arche-artificial-main-image img') ||
      optionEl.querySelector('.table-honneur-image img') ||
      optionEl.querySelector('img');
    if (!targetImg) return false;

    var ok = applyUrlsToImg(targetImg, urls);
    if (ok) {
      var wrapper = targetImg.closest('#arche-artificial-main-image');
      if (wrapper) wrapper.style.display = '';
    }
    return ok;
  };
  window.__questionnaireMediaSimpleBoot = boot;

})();
